import { Reducer } from "redux";
import {
	ReportsActions,
	ReportsActionTypes
} from "../../Actions/Reports/Reports.action";
import {
	Report,
	ReportConfig,
	CreateReportFormState,
	CreateReportFormStateInterface
} from "@/Contracts/Reports/Reports.contract";

export class ReportsState {
	readonly isLoading: boolean = false;
	readonly isFormDirty: boolean = false;
	readonly reportsList: Report[] = [];
	readonly currentActiveReport: Report | null = null;
	readonly reportConfig: ReportConfig | null = null;
	readonly createReportForm: CreateReportFormStateInterface =
		new CreateReportFormState();
	readonly createReportDisplayError: string | null = null;
}

export const ReportsReducer: Reducer<ReportsState, ReportsActions> = (
	state: ReportsState = new ReportsState(),
	action: ReportsActions
): ReportsState => {
	switch (action.type) {
		case ReportsActionTypes.SHOW_REPORTS_LOADER: {
			return {
				...state,
				isLoading: true
			};
		}
		case ReportsActionTypes.HIDE_REPORTS_LOADER: {
			return {
				...state,
				isLoading: false
			};
		}
		case ReportsActionTypes.GET_REPORTS_LIST_REQUESTED: {
			return state;
		}
		case ReportsActionTypes.GET_REPORTS_LIST_SUCCESSFUL: {
			return {
				...state,
				reportsList: action.reportsList
			};
		}
		case ReportsActionTypes.GET_REPORTS_CONFIG_FAILED: {
			return state;
		}
		case ReportsActionTypes.GET_REPORTS_CONFIG_REQUESTED: {
			return state;
		}
		case ReportsActionTypes.GET_REPORTS_CONFIG_SUCCESSFUL: {
			return {
				...state,
				reportConfig: action.reportConfig
			};
		}
		case ReportsActionTypes.GET_REPORTS_LIST_FAILED: {
			return state;
		}
		case ReportsActionTypes.GET_REPORTS_DETAILS_REQUESTED: {
			return { ...state, createReportDisplayError: null };
		}
		case ReportsActionTypes.GET_REPORTS_DETAILS_SUCCESSFUL: {
			return {
				...state,
				currentActiveReport: action.currentActiveReport,
				isFormDirty: false,
				createReportForm:
					action.currentActiveReport as CreateReportFormStateInterface
			};
		}
		case ReportsActionTypes.RESET_REPORTS_DETAILS: {
			return {
				...state,
				isFormDirty: false,
				currentActiveReport: null
			};
		}

		case ReportsActionTypes.CREATE_REPORT_PREVIEW_FAILED: {
			return {
				...state,
				createReportDisplayError: action.errorMessage,
				currentActiveReport: null
			};
		}

		case ReportsActionTypes.CREATE_REPORT_PREVIEW_REQUESTED: {
			return {
				...state,
				createReportForm: action.createReportForm,
				createReportDisplayError: null
			};
		}

		case ReportsActionTypes.RESET_CREATE_REPORT_FORM: {
			return {
				...state,
				isFormDirty: true,
				createReportForm: new CreateReportFormState()
			};
		}

		case ReportsActionTypes.CREATE_REPORT_PREVIEW_SUCCESSFUL: {
			return {
				...state,
				isFormDirty: true,
				currentActiveReport: action.currentActiveReport
			};
		}

		case ReportsActionTypes.GET_REPORTS_DETAILS_FAILED: {
			return state;
		}

		case ReportsActionTypes.CREATE_REPORT_FAILED: {
			return state;
		}
		case ReportsActionTypes.CREATE_REPORT_REQUESTED: {
			return state;
		}
		case ReportsActionTypes.CREATE_REPORT_SUCCESSFUL: {
			return state;
		}

		case ReportsActionTypes.UPDATE_REPORT_REQUESTED: {
			return state;
		}
		case ReportsActionTypes.UPDATE_REPORT_SUCCESSFUL: {
			return {
				...state,
				currentActiveReport: action.report,
				isFormDirty: false
			};
		}
		case ReportsActionTypes.UPDATE_REPORT_FAILED: {
			return {
				...state,
				createReportDisplayError: action.errorMessage || null
			};
		}

		case ReportsActionTypes.UPDATE_REPORT_NAME_REQUESTED: {
			return state;
		}
		case ReportsActionTypes.UPDATE_REPORT_NAME_SUCCESSFUL: {
			return {
				...state,
				currentActiveReport: {
					...(state.currentActiveReport as Report),
					name: action.reportName
				}
			};
		}
		case ReportsActionTypes.UPDATE_REPORT_NAME_FAILED: {
			return state;
		}
		default: {
			return state;
		}
	}
};

export default ReportsReducer;
